// const BaseApi = 'http://localhost:1337'
const BaseApi = 'https://buynow-backend1.herokuapp.com'

export default BaseApi;